import {
	AAFieldPopperSX,
	AAFieldTooltipSX,
	AATooltipButtonTopRightSX,
} from '@/components/blocks/AddressForm/styles/fieldTooltip';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

type Props = {
	content: ReactNode;
	id?: string;
};

export const FieldTooltipTopRight: FC<Props> = ({ content, id }) => {
	const theme = useTheme();

	return (
		<Tooltip
			title={content}
			placement="bottom"
			slotProps={{
				tooltip: { sx: AAFieldTooltipSX },
				popper: {
					sx: AAFieldPopperSX,
				},
			}}
			tabIndex={-1}
		>
			<Box top={5} right={5} position="absolute" display="flex">
				<IconButton id={id} disableRipple sx={AATooltipButtonTopRightSX}>
					<DynamicIcon
						name={MATERIAL_SYMBOL_ICONS.helpCenter}
						color={theme.palette.primary.main}
						variant="filled"
						size={14}
					/>
				</IconButton>
			</Box>
		</Tooltip>
	);
};
